<div class="draft-desktop-heading">
  <span class="draft-search-title label-medium-emphasized">{{ 'receipts.ui.ricerca' | transloco }}</span>

  <button
    matButton="filled"
    type="button"
    class="desktop-new-draft-button"
    *uiCan="CAPS.brogliaccioCrea"
    [routerLink]="['new']"
  >
    <i class="fa-regular fa-plus" aria-hidden="true"></i>
    {{ 'receipts.ui.nuovoBrogliaccio' | transloco }}
  </button>
</div>

<section class="draft-search">
  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="draft-date-field draft-date-field--from">
    <mat-label>{{ 'receipts.ui.dal' | transloco }}</mat-label>
    <input
      matInput
      [matDatepicker]="dateFromPicker"
      [(ngModel)]="dateFrom"
      [placeholder]="'receipts.ui.datePlaceholder' | transloco"
    />
    <mat-datepicker-toggle matIconSuffix [for]="dateFromPicker" />
    <mat-datepicker #dateFromPicker />
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="draft-date-field draft-date-field--to">
    <mat-label>{{ 'receipts.ui.al' | transloco }}</mat-label>
    <input
      matInput
      [matDatepicker]="dateToPicker"
      [min]="dateFrom"
      [(ngModel)]="dateTo"
      [placeholder]="'receipts.ui.datePlaceholder' | transloco"
    />
    <mat-datepicker-toggle matIconSuffix [for]="dateToPicker" />
    <mat-datepicker #dateToPicker />
    @if (dateRangeInvalid) {
      <mat-error>{{ 'receipts.ui.laDataAlNonPuoEsserePrecedenteAllaDataDal' | transloco }}</mat-error>
    }
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="draft-status-field">
    <mat-label>{{ 'receipts.ui.statoBrogliaccio' | transloco }}</mat-label>
    <mat-select multiple [(ngModel)]="selectedStatuses">
      @for (status of statusOptions; track status.value) {
        <mat-option [value]="status.value">{{ status.label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <button matButton="filled" type="button" class="draft-search-button draft-search-button--desktop" (click)="cerca()">
    {{ 'receipts.ui.cerca' | transloco }}
  </button>

  <button matButton="outlined" type="button" class="draft-search-button draft-search-button--desktop" (click)="resetta()">
    {{ 'receipts.ui.azzeraFiltri' | transloco }}
  </button>

  @if (isLoading) {
    <ui-loading-spinner></ui-loading-spinner>
  } @else {
    <div class="draft-results">
      @for (brogliaccio of brogliacci; track brogliaccio.id) {
        <div
          class="draft-card"
          role="link"
          tabindex="0"
          (click)="apriDettaglio(brogliaccio.id)"
          (keydown.enter)="apriDettaglio(brogliaccio.id)"
        >
          <div class="draft-card-content">
            <div class="draft-card-column">
              <span class="body-medium-emphasized">
                {{ 'receipts.ui.brogliaccioN' | transloco: { value0: (brogliaccio.numeroBrogliaccio) } }}
              </span>
              <span class="body-medium">
                {{ 'receipts.ui.data2' | transloco: { value0: (brogliaccio.data | date:'dd/MM/yyyy') } }}
              </span>
              <!--
              <span class="body-medium">
                {{ brogliaccio.numeroIncassi }}
                {{ brogliaccio.numeroIncassi === 1 ? 'incasso' : 'incassi' }}
              </span>
              -->
            </div>

            <div class="draft-card-column draft-card-column--end">
              <span class="body-medium-emphasized">
                {{ brogliaccio.importoTotale | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
              </span>
              <span class="body-medium draft-status-badge" [ngClass]="statusBadgeClass(brogliaccio.situazione)">
                {{ brogliaccio.situazione }}
              </span>
            </div>
          </div>
          <div class="draft-card-action" aria-hidden="true">
            <i class="fa-regular fa-chevron-right"></i>
          </div>
        </div>
      } @empty {
        <span class="title-small">{{ 'receipts.ui.nessunBrogliaccioTrovato' | transloco }}</span>
      }
    </div>

    <ui-table-view
      class="draft-desktop-table"
      [columnsInfo]="brogliacciColumns"
      [data]="brogliacciTable"
      (rowClicked)="apriDettaglio($event.id)"
    />

    <mat-paginator
      class="draft-paginator"
      [length]="totalItems"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="[5, 10, 25]"
      [hidePageSize]="true"
      (page)="onPageChange($event)"
    >
    </mat-paginator>
  }
</section>

<button matFab extended type="button" class="new-draft-button" *uiCan="CAPS.brogliaccioCrea"
  [routerLink]="['new']">
  <i class="fa-regular fa-plus" aria-hidden="true"></i>
  <span class="new-draft-label title-medium">{{ 'receipts.ui.nuovoBrogliaccio' | transloco }}</span>
</button>
